// extracted by mini-css-extract-plugin
module.exports = {"submenuContent":"Submenu_submenuContent__1QtQk","items":"Submenu_items__k9Ret","itemul":"Submenu_itemul__30r73","itemli":"Submenu_itemli__1fR4X","btn":"Submenu_btn__H1-sE"};